import React from 'react'
import PropTypes from 'prop-types'

import Container from '@hixme-ui/container'
import RadioButton from '@hixme-ui/radio-button'

import { FieldError } from 'components/ReduxFormComponents'

const RenderGenderRadio = ({ input, meta, disabled, ...rest }) => (
  <Container flex noPadding direction="column">
    <Container flex justifyCenter alignCenter padding="8px 0" {...rest}>
      <div style={{ width: '80px', marginRight: '15px' }}>
        <RadioButton
          name="male"
          {...input}
          text="Male"
          value="Male"
          disabled={disabled}
          checked={input.value === 'Male'}
        />
      </div>
      <div style={{ width: '80px', marginRight: '15px' }}>
        <RadioButton
          name="female"
          {...input}
          text="Female"
          value="Female"
          disabled={disabled}
          checked={input.value === 'Female'}
        />
      </div>
    </Container>
    <FieldError meta={meta} />
  </Container>
)

RenderGenderRadio.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  disabled: PropTypes.bool,
}

RenderGenderRadio.defaultProps = {
  input: {},
  meta: {},
  disabled: false,
}

export default RenderGenderRadio
